// Lightweight i18n strings for AFRICAN VALLEY PILOTAGE PROJET (FR / EN)
export const translations = {
    fr: {
        brand: 'African Valley',
        brand_full: 'African Valley Pilotage Projet',
        tagline: 'Plateforme intelligente africaine de gouvernance, pilotage financier, gestion collaborative et suivi des projets financés.',
        nav: {
            features: 'Modules',
            usecases: 'Cas d’usage',
            security: 'Sécurité',
            contact: 'Contact',
            signin: 'Connexion',
            signup: 'Demander un accès',
            dashboard: 'Tableau de bord',
            projects: 'Projets',
            formation: 'Campus 360°',
            ged: 'GED',
            audit: 'Audit',
            ai: 'Assistant IA',
            admin: 'Administration',
            team: 'Équipe',
            guide: 'Guide',
            grants: 'Subventions',
            courriers: 'Courriers',
            templates: 'Modèles',
            marketplace: 'Marketplace',
            orders: 'Commandes',
            branding: 'Branding',
            'super-admin': 'Super Admin',
            approvals: 'Validations',
            exports: 'Exports',
            admin_group: "Gestion de l'espace",
            signout: 'Déconnexion',
        },
        landing: {
            badge: 'B2B / B2G — Multi-tenant DeepSec',
            hero_title_1: 'Pilotez vos projets financés',
            hero_title_2: 'avec souveraineté.',
            hero_sub: 'ERP de gouvernance projet, GED intelligente, pilotage budgétaire, reporting bailleurs et assistant IA — pour entreprises, ONG, institutions et collectivités africaines.',
            cta_primary: 'Démarrer un espace client',
            cta_secondary: 'Découvrir la formation',
            kpi_1_label: 'Cloisonnement', kpi_1_value: '100% RLS',
            kpi_2_label: 'Jalons projet', kpi_2_value: 'APS → Clôture',
            kpi_3_label: 'Reporting', kpi_3_value: 'COMEX / DAF / Bailleurs',
            kpi_4_label: 'IA décisionnelle', kpi_4_value: 'Claude Sonnet 4.5',
            modules_title: 'Une suite intégrée de pilotage stratégique',
            modules_sub: 'Tout ce dont vos directions ont besoin pour piloter, financer et auditer leurs projets, dans un environnement africain souverain.',
            usecases_title: 'Cas d’usage africains immersifs',
            usecases_sub: 'Apprenez par la pratique sur des scénarios natifs : énergie, santé, ONG, infrastructures, mines, agriculture.',
            security_title: 'Architecture DeepSec, multi-tenant stricte',
            security_sub: 'Chaque client opère dans un espace privé totalement étanche : RLS Supabase sur chaque table, audit logs immuables, URLs signées, RBAC fin.',
            footer_rights: 'Tous droits réservés.',
        },
        auth: {
            signin_title: 'Connexion à votre espace',
            signup_title: 'Créer votre espace client',
            email: 'Email professionnel',
            password: 'Mot de passe',
            full_name: 'Nom complet',
            workspace: 'Nom de l’organisation',
            submit_signin: 'Se connecter',
            submit_signup: 'Créer mon espace',
            switch_to_signup: 'Pas encore de compte ? Créer un espace client',
            switch_to_signin: 'Déjà inscrit ? Se connecter',
            error: 'Une erreur est survenue. Vérifiez vos identifiants.',
            email_confirm_pending: 'Vérifiez votre email pour confirmer votre compte, puis connectez-vous.',
        },
        dashboard: {
            welcome: 'Bonjour',
            overview: 'Vue d’ensemble exécutive',
            kpi_projects: 'Projets actifs',
            kpi_budget: 'Budget engagé',
            kpi_spent: 'Dépenses',
            kpi_alerts: 'Alertes IA',
            recent_projects: 'Projets récents',
            recent_audit: 'Activité récente',
            no_projects: 'Aucun projet pour le moment. Créez votre premier projet.',
            create_project: 'Nouveau projet',
        },
        projects: {
            list_title: 'Portefeuille projets',
            new: 'Nouveau projet',
            code: 'Code',
            name: 'Nom',
            sector: 'Secteur',
            status: 'Statut',
            budget: 'Budget',
            progress: 'Avancement',
            create_title: 'Créer un nouveau projet',
            create_subtitle: 'Renseignez les informations clés. Vous pourrez compléter les phases, le budget et le GANTT ensuite.',
            field_name: 'Nom du projet',
            field_code: 'Code projet',
            field_industry: 'Secteur',
            field_country: 'Pays',
            field_budget: 'Budget prévisionnel',
            field_currency: 'Devise',
            field_start: 'Date de début',
            field_end: 'Date de fin',
            field_description: 'Description',
            create_submit: 'Créer le projet',
            tabs: {
                overview: 'Synthèse',
                gantt: 'GANTT',
                phases: 'Phases',
                budget: 'Budget',
                ged: 'GED',
                ai: 'Assistant IA',
                audit: 'Audit',
            },
        },
        phases: {
            add: 'Ajouter une phase',
            milestones: 'Jalons',
            label: {
                mandat: 'Mandat', aps: 'APS', apd: 'APD', faisabilite: 'Faisabilité',
                contrat: 'Contrat', travaux: 'Travaux', reception: 'Réception',
                attestation: 'Attestation', cloture: 'Clôture',
            },
        },
        ged: {
            title: 'Gestion électronique des documents',
            upload: 'Téléverser un document',
            empty: 'Aucun document. Téléversez devis, factures, contrats, photos, rapports…',
            name: 'Document',
            category: 'Catégorie',
            size: 'Taille',
            uploaded_at: 'Téléversé le',
            download: 'Télécharger',
        },
        ai: {
            title: 'Assistant IA — Pilotage & Reporting',
            placeholder: 'Posez une question, demandez une synthèse DAF, un reporting bailleur, une détection d’incohérence…',
            send: 'Envoyer',
            thinking: 'Analyse en cours…',
            suggestions_title: 'Suggestions',
            sug_1: 'Synthèse DAF du mois',
            sug_2: 'Détecter pièces manquantes',
            sug_3: 'Identifier risques de retard',
            sug_4: 'Préparer une note COMEX',
        },
        formation: {
            title: 'Espace Formation',
            sub: 'Use cases africains immersifs pour vous former au pilotage projet, au financement, à la GED et au reporting bailleurs.',
            start: 'Commencer',
            duration: 'min',
            module: 'Module',
        },
        audit: {
            title: 'Audit & Conformité',
            sub: 'Journal immuable des actions sensibles sur votre espace.',
            empty: 'Aucune activité enregistrée pour le moment.',
            action: 'Action',
            user: 'Utilisateur',
            entity: 'Objet',
            date: 'Date',
        },
        admin: {
            title: 'Administration de l’espace',
            members: 'Membres',
            invite: 'Inviter un membre',
            email: 'Email',
            role: 'Rôle',
            is_admin: 'Admin',
            add: 'Ajouter',
            workspace_settings: 'Paramètres organisation',
        },
        common: {
            cancel: 'Annuler', save: 'Enregistrer', delete: 'Supprimer',
            close: 'Fermer', loading: 'Chargement…', search: 'Rechercher',
            actions: 'Actions', back: 'Retour', yes: 'Oui', no: 'Non',
            error_generic: 'Une erreur est survenue',
            no_workspace: 'Aucun espace client',
            create_workspace: 'Créer un espace client',
            workspace_name: 'Nom de l’organisation',
            country: 'Pays',
            industry: 'Secteur',
            create: 'Créer',
            currency: 'Devise',
            start_date: 'Date de début',
            end_date: 'Date de fin',
        },
        grants: {
            eyebrow: 'Bailleurs & financement',
            title: 'Subventions, donations et impact',
            sub: 'Gérez vos bailleurs, conventions de financement et indicateurs d’impact pour le reporting bailleur.',
            kpi_donors: 'Bailleurs', kpi_grants: 'Subventions', kpi_total: 'Montant total',
            tab_grants: 'Subventions', tab_donors: 'Bailleurs', tab_impact: 'Impact',
            new_grant: 'Nouvelle subvention', new_donor: 'Nouveau bailleur', new_indicator: 'Nouvel indicateur',
            col_donor: 'Bailleur', col_project: 'Projet', col_ref: 'Référence',
            col_amount: 'Montant', col_period: 'Période',
            col_name: 'Nom', col_country: 'Pays', col_contact: 'Contact',
            col_indicator: 'Indicateur', col_target: 'Cible', col_current: 'Actuel', col_unit: 'Unité', col_category: 'Catégorie',
            empty_grants: 'Aucune subvention enregistrée.', empty_donors: 'Aucun bailleur enregistré.', empty_impact: 'Aucun indicateur d’impact.',
        },
        courriers: {
            eyebrow: 'Correspondance',
            title: 'Courriers entrants & sortants',
            sub: 'Journal centralisé de toute la correspondance officielle liée à vos projets.',
            new: 'Nouveau courrier',
            col_direction: 'Sens', col_subject: 'Objet', col_party: 'Partie', col_project: 'Projet', col_date: 'Date', col_ref: 'Référence',
            from: 'Expéditeur', to: 'Destinataire', body: 'Contenu',
            inbound: 'Reçu', outbound: 'Envoyé',
            empty: 'Aucun courrier enregistré.',
        },
        exports: {
            eyebrow: 'Exports & livrables',
            title: 'Exports premium',
            sub: 'Générez des livrables premium prêts pour DAF, COMEX et bailleurs.',
            synthesis: 'Synthèse exécutive PDF', synthesis_sub: 'Note 1 page avec KPIs + synthèse IA Claude.',
            budget: 'Tableau budget Excel', budget_sub: 'Multi-feuilles : synthèse, lignes, dépenses.',
            comex: 'Brief COMEX PowerPoint', comex_sub: 'Slides prêtes à présenter au comité exécutif.',
            attestation: 'Attestation PDF', attestation_sub: 'Attestation officielle (achèvement, réception, paiement, clôture).',
            attestation_cta: 'Générer l’attestation',
            attestation_kind: 'Type d’attestation', attestation_signer: 'Signataire', attestation_extra: 'Observations',
            attestation_extra_ph: 'Mentions complémentaires (optionnel)…',
            download: 'Télécharger',
        },
        invitations: {
            sent: 'Invitation envoyée par email.',
            link_copy: 'Lien d’invitation copié dans le presse-papier.',
            smtp_missing: 'SMTP non configuré — le lien a été généré et copié.',
        },
        approvals: {
            title: 'File de validations',
            sub: 'Toutes les demandes de validation en attente dans votre espace.',
            empty: 'Aucune validation en attente.',
        },
        templates: {
            title: 'Modèles documentaires',
            sub: 'Téléversez des modèles .docx ou .xlsx contenant des placeholders {{project.name}}, {{budget.spent}}, etc. — ils seront fusionnés avec les données d’un projet.',
            upload: 'Téléverser un modèle',
            empty: 'Aucun modèle. Téléversez un fichier .docx ou .xlsx avec des placeholders.',
        },
    },
    en: {
        brand: 'African Valley',
        brand_full: 'African Valley Project Governance',
        tagline: 'Intelligent African platform for governance, financial steering, collaborative management and financed project tracking.',
        nav: {
            features: 'Modules', usecases: 'Use cases', security: 'Security', contact: 'Contact',
            signin: 'Sign in', signup: 'Request access',
            dashboard: 'Dashboard', projects: 'Projects', formation: 'Campus 360°',
            ged: 'Documents', audit: 'Audit', ai: 'AI Assistant', admin: 'Admin',
            team: 'Team',
            guide: 'Guide',
            grants: 'Grants', courriers: 'Mail', templates: 'Templates',
            approvals: 'Approvals', marketplace: 'Marketplace', branding: 'Branding',
            orders: 'Orders',
            'super-admin': 'Super Admin',
            admin_group: 'Workspace management',
            signout: 'Sign out',
        },
        landing: {
            badge: 'B2B / B2G — DeepSec multi-tenant',
            hero_title_1: 'Steer your financed projects',
            hero_title_2: 'with sovereignty.',
            hero_sub: 'Project-governance ERP, intelligent document management, budget steering, donor reporting and AI assistant — for African companies, NGOs, institutions and authorities.',
            cta_primary: 'Open a client workspace',
            cta_secondary: 'Explore training',
            kpi_1_label: 'Isolation', kpi_1_value: '100% RLS',
            kpi_2_label: 'Project milestones', kpi_2_value: 'APS → Closure',
            kpi_3_label: 'Reporting', kpi_3_value: 'COMEX / CFO / Donors',
            kpi_4_label: 'Decision AI', kpi_4_value: 'Claude Sonnet 4.5',
            modules_title: 'An integrated strategic-steering suite',
            modules_sub: 'Everything your leadership needs to steer, finance and audit projects — in a sovereign African environment.',
            usecases_title: 'Immersive African use cases',
            usecases_sub: 'Learn by doing on native scenarios: energy, health, NGO, infrastructure, mining, agriculture.',
            security_title: 'DeepSec architecture, strict multi-tenant',
            security_sub: 'Every client operates in a fully isolated private space: Supabase RLS on every table, immutable audit logs, signed URLs, fine-grained RBAC.',
            footer_rights: 'All rights reserved.',
        },
        auth: {
            signin_title: 'Sign in to your workspace', signup_title: 'Create your client workspace',
            email: 'Work email', password: 'Password', full_name: 'Full name', workspace: 'Organization name',
            submit_signin: 'Sign in', submit_signup: 'Create workspace',
            switch_to_signup: 'No account yet? Create a workspace',
            switch_to_signin: 'Already registered? Sign in',
            error: 'Something went wrong. Please check your credentials.',
            email_confirm_pending: 'Check your email to confirm your account, then sign in.',
        },
        dashboard: {
            welcome: 'Welcome', overview: 'Executive overview',
            kpi_projects: 'Active projects', kpi_budget: 'Committed budget',
            kpi_spent: 'Spent', kpi_alerts: 'AI alerts',
            recent_projects: 'Recent projects', recent_audit: 'Recent activity',
            no_projects: 'No projects yet. Create your first one.', create_project: 'New project',
        },
        projects: {
            list_title: 'Project portfolio', new: 'New project',
            code: 'Code', name: 'Name', sector: 'Sector', status: 'Status', budget: 'Budget', progress: 'Progress',
            create_title: 'Create a new project',
            create_subtitle: 'Fill in the key information. You can complete phases, budget and Gantt afterwards.',
            field_name: 'Project name', field_code: 'Project code', field_industry: 'Sector',
            field_country: 'Country', field_budget: 'Planned budget', field_currency: 'Currency',
            field_start: 'Start date', field_end: 'End date', field_description: 'Description',
            create_submit: 'Create project',
            tabs: { overview: 'Overview', gantt: 'Gantt', phases: 'Phases', budget: 'Budget', ged: 'Documents', ai: 'AI Assistant', audit: 'Audit' },
        },
        phases: {
            add: 'Add phase', milestones: 'Milestones',
            label: { mandat: 'Mandate', aps: 'APS', apd: 'APD', faisabilite: 'Feasibility', contrat: 'Contract', travaux: 'Works', reception: 'Reception', attestation: 'Certificate', cloture: 'Closure' },
        },
        ged: {
            title: 'Electronic document management', upload: 'Upload document',
            empty: 'No document yet. Upload quotes, invoices, contracts, photos, reports…',
            name: 'Document', category: 'Category', size: 'Size', uploaded_at: 'Uploaded', download: 'Download',
        },
        ai: {
            title: 'AI Assistant — Steering & Reporting',
            placeholder: 'Ask a question, request a CFO summary, donor reporting, inconsistency detection…',
            send: 'Send', thinking: 'Thinking…',
            suggestions_title: 'Suggestions',
            sug_1: 'Monthly CFO summary', sug_2: 'Detect missing documents',
            sug_3: 'Identify delay risks', sug_4: 'Prepare a COMEX note',
        },
        formation: {
            title: 'Training space',
            sub: 'Immersive African use cases to learn project steering, financing, document management and donor reporting.',
            start: 'Start', duration: 'min', module: 'Module',
        },
        audit: {
            title: 'Audit & Compliance', sub: 'Immutable log of sensitive actions on your workspace.',
            empty: 'No activity recorded yet.', action: 'Action', user: 'User', entity: 'Object', date: 'Date',
        },
        admin: {
            title: 'Workspace administration', members: 'Members', invite: 'Invite a member',
            email: 'Email', role: 'Role', is_admin: 'Admin', add: 'Add', workspace_settings: 'Workspace settings',
        },
        common: {
            cancel: 'Cancel', save: 'Save', delete: 'Delete', close: 'Close', loading: 'Loading…',
            search: 'Search', actions: 'Actions', back: 'Back', yes: 'Yes', no: 'No',
            error_generic: 'Something went wrong', no_workspace: 'No client workspace',
            create_workspace: 'Create a client workspace', workspace_name: 'Organization name',
            country: 'Country', industry: 'Sector', create: 'Create',
            currency: 'Currency', start_date: 'Start date', end_date: 'End date',
        },
        grants: {
            eyebrow: 'Donors & financing', title: 'Grants, donations and impact',
            sub: 'Manage donors, financing agreements and impact indicators for donor reporting.',
            kpi_donors: 'Donors', kpi_grants: 'Grants', kpi_total: 'Total amount',
            tab_grants: 'Grants', tab_donors: 'Donors', tab_impact: 'Impact',
            new_grant: 'New grant', new_donor: 'New donor', new_indicator: 'New indicator',
            col_donor: 'Donor', col_project: 'Project', col_ref: 'Reference',
            col_amount: 'Amount', col_period: 'Period',
            col_name: 'Name', col_country: 'Country', col_contact: 'Contact',
            col_indicator: 'Indicator', col_target: 'Target', col_current: 'Current', col_unit: 'Unit', col_category: 'Category',
            empty_grants: 'No grants yet.', empty_donors: 'No donors yet.', empty_impact: 'No impact indicators yet.',
        },
        courriers: {
            eyebrow: 'Correspondence', title: 'Inbound & outbound mail',
            sub: 'Central log of all official correspondence tied to your projects.',
            new: 'New mail',
            col_direction: 'Direction', col_subject: 'Subject', col_party: 'Party', col_project: 'Project', col_date: 'Date', col_ref: 'Reference',
            from: 'From', to: 'To', body: 'Body',
            inbound: 'Inbound', outbound: 'Outbound',
            empty: 'No correspondence yet.',
        },
        exports: {
            eyebrow: 'Exports & deliverables', title: 'Premium exports',
            sub: 'Generate executive-ready deliverables for CFO, COMEX and donors.',
            synthesis: 'Executive PDF', synthesis_sub: 'One-pager with KPIs + AI Claude summary.',
            budget: 'Budget Excel', budget_sub: 'Multi-sheet: overview, lines, expenses.',
            comex: 'COMEX PowerPoint', comex_sub: 'Slides ready to present to the executive committee.',
            attestation: 'PDF certificate', attestation_sub: 'Official certificate (completion, reception, payment, closure).',
            attestation_cta: 'Generate certificate',
            attestation_kind: 'Certificate type', attestation_signer: 'Signed by', attestation_extra: 'Notes',
            attestation_extra_ph: 'Additional mentions (optional)…',
            download: 'Download',
        },
        invitations: {
            sent: 'Invitation sent by email.',
            link_copy: 'Invitation link copied to clipboard.',
            smtp_missing: 'SMTP not configured — link generated and copied.',
        },
        approvals: {
            title: 'Approvals queue',
            sub: 'All pending approval requests in your workspace.',
            empty: 'No pending approvals.',
        },
        templates: {
            title: 'Document templates',
            sub: 'Upload .docx or .xlsx templates with placeholders like {{project.name}}, {{budget.spent}} — they will be merged with project data.',
            upload: 'Upload template',
            empty: 'No templates yet. Upload a .docx or .xlsx file with placeholders.',
        },
    },
};
